export function iteratorSome(iterator, callbackfn) {
    let result;
    let index = 0;
    while (true) {
        result = iterator.next();
        if (result.done) {
            return false;
        }
        if (callbackfn(result.value, index)) {
            return true;
        }
        index += 1;
    }
}
export function iteratorEvery(iterator, callbackfn) {
    let result;
    let index = 0;
    while (true) {
        result = iterator.next();
        if (result.done) {
            return true;
        }
        if (!callbackfn(result.value, index)) {
            return false;
        }
        index += 1;
    }
}
export function iteratorFind(iterator, callbackfn) {
    let result;
    let index = 0;
    while (true) {
        result = iterator.next();
        if (result.done) {
            return undefined;
        }
        if (callbackfn(result.value, index)) {
            return result.value;
        }
        index += 1;
    }
}
export function iteratorFindIndex(iterator, callbackfn) {
    let result;
    let index = 0;
    while (true) {
        result = iterator.next();
        if (result.done) {
            return -1;
        }
        if (callbackfn(result.value, index)) {
            return index;
        }
        index += 1;
    }
}
export function iteratorFilterToArray(iterator, callbackfn) {
    let result;
    let index = 0;
    const ret = [];
    while (true) {
        result = iterator.next();
        if (result.done) {
            return ret;
        }
        if (callbackfn(result.value, index)) {
            ret.push(result.value);
        }
        index += 1;
    }
}
export function iteratorReduce(iterator, callbackfn, initialValue) {
    let result;
    let index = 0;
    while (true) {
        result = iterator.next();
        if (result.done) {
            return initialValue;
        }
        initialValue = callbackfn(initialValue, result.value, index);
        index += 1;
    }
}
export function iteratorSliceToArray(iterator, start = 0, end = Infinity) {
    const ret = [];
    let index = 0;
    while (true) {
        const result = iterator.next();
        if (result.done || index > end) {
            return ret;
        }
        if (index >= start) {
            ret.push(result.value);
        }
        index++;
    }
}
export default {
    iteratorSome,
    iteratorEvery,
    iteratorFind,
    iteratorFindIndex,
    iteratorFilterToArray,
    iteratorReduce,
    iteratorSliceToArray,
};
